export const PAGE_LOADER_STYLE = {
  position: 'fixed',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(255, 255, 255, 0)',
  zIndex: 10,
  margin: '10px 0px',
};

export function disablePageScroll() {
  let el = document.getElementsByTagName('html')[0];
  el.style.overflow = 'hidden';
}

export function enablePageScroll() {
  let el = document.getElementsByTagName('html')[0];
  el.style.overflow = 'auto';
}

// Set the focus on the field also move the focus to the end of the input text
export function setFocusOnTextField(textfield) {
  textfield && textfield.focus();
}

export function enableTransparentPage() {
  let el = document.getElementById('root');
  el.style.backgroundColor = 'transparent';
}

export function disableTransparentPage() {
  let el = document.getElementById('root');
  el.removeAttribute('style');
}

export function enableMarginForTheContainer() {
  let el = document.getElementById('container');
  if (el) {
    el.removeAttribute('style');
  }
}

export function disableMarginForTheContainer() {
  let el = document.getElementById('container');
  if (el) {
    el.style.margin = '0px';
  }
}

export function reactSelectTheme() {
  return (theme) => ({
    ...theme,
    borderRadius: 0,
    colors: {
      ...theme.colors,
      primary25: theme.colors.primary50,
      primary: '#084782',
    },
  });
}
